import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { getLayoutMode } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/merchandiser/helpers/LayoutMerchandiser';

import { calculateMerchandiserInternalsLandscape } from './MerchandiserLayoutLandscape';
import { calculateMerchandiserInternalsPortrait } from './MerchandiserLayoutPortrait';

export const calculateMerchandiserInternals = (
  gridCard: GridCard<PlaneTypes.Layout_Merchandiser>
) => {
  if (getLayoutMode() === 'landscape') {
    calculateMerchandiserInternalsLandscape(gridCard);
    return;
  }

  calculateMerchandiserInternalsPortrait(gridCard);
};
